<div class="permission-dialog-container">

  <form
    [formGroup]="formGroup"
    class="permission-form"
    (ngSubmit)="confirm()"
  >

    <!-- DELEGATO -->

    <div class="permission-field">

      <label
        class="permission-label"
        for="permission-delegate"
      >
        Delegato
        <span class="permission-required">*</span>
      </label>

      <p-dropdown
        inputId="permission-delegate"
        styleClass="permission-dropdown"
        [style]="{ width: '100%' }"
        [options]="delegates"
        [(ngModel)]="selectedDelegate"
        formControlName="delegate"
        placeholder="Seleziona un delegato"
        [filter]="true"
        filterBy="user.name,user.lastName"
        [showClear]="false"
        appendTo="body"
      >

        <ng-template pTemplate="selectedItem">
          <span *ngIf="selectedDelegate">
            {{ selectedDelegate.user!.name }}
            {{ selectedDelegate.user!.lastName }}
          </span>
        </ng-template>

        <ng-template pTemplate="item" let-option>
          <span>
            {{ option.user.name }}
            {{ option.user.lastName }}
          </span>
        </ng-template>

      </p-dropdown>

    </div>

    <!-- DATA PERMESSO -->

    <div class="permission-field">

      <label
        class="permission-label"
        for="permission-date"
      >
        Data permesso
        <span class="permission-required">*</span>
      </label>

      <p-calendar
        inputId="permission-date"
        styleClass="permission-calendar"
        [style]="{ width: '100%' }"
        [inputStyle]="{ width: '100%' }"
        formControlName="permissionDate"
        [(ngModel)]="permission.permissionDate"
        dateFormat="dd/mm/yy"
        [inline]="false"
        [showIcon]="true"
        [showButtonBar]="true"
        [minDate]="minDate"
        [readonlyInput]="false"
        appendTo="body"
        placeholder="gg/mm/aaaa"
      ></p-calendar>

    </div>

    <!-- ORARI -->

    <div class="permission-time-section">

      <div class="permission-subsection-heading">
        <i class="pi pi-clock"></i>
        <span>Fascia oraria</span>
      </div>

      <div class="permission-time-grid">

        <div class="permission-field">

          <label
            class="permission-label"
            for="permission-start-time"
          >
            Ora di inizio
          </label>

          <p-calendar
            inputId="permission-start-time"
            styleClass="permission-time-calendar"
            [style]="{ width: '100%' }"
            [inputStyle]="{ width: '100%' }"
            formControlName="startTime"
            [(ngModel)]="permission.startTime"
            [timeOnly]="true"
            [hourFormat]="'24'"
            [disabled]="permission.isDaily"
            appendTo="body"
          ></p-calendar>

        </div>

        <div class="permission-field">

          <label
            class="permission-label"
            for="permission-end-time"
          >
            Ora di fine
          </label>

          <p-calendar
            inputId="permission-end-time"
            styleClass="permission-time-calendar"
            [style]="{ width: '100%' }"
            [inputStyle]="{ width: '100%' }"
            formControlName="endTime"
            [(ngModel)]="permission.endTime"
            [timeOnly]="true"
            [hourFormat]="'24'"
            [disabled]="permission.isDaily"
            appendTo="body"
          ></p-calendar>

        </div>

      </div>

    </div>

    <!-- ARTICOLO -->

    <div class="permission-field">

      <label class="permission-label">
        Articolo
        <span class="permission-required">*</span>
      </label>

      <div class="permission-article-container">

        <p-selectButton
          [allowEmpty]="false"
          [options]="artOptions"
          formControlName="article"
          [(ngModel)]="permission.article"
          styleClass="permission-article-selector"
        >
          <ng-template let-item pTemplate>
            {{ artOptionStrings[item] }}
          </ng-template>
        </p-selectButton>

      </div>

    </div>

    <!-- PERMESSO GIORNALIERO -->

    <div class="permission-daily-container">

      <div class="permission-daily-description">

        <span class="permission-label">
          Permesso giornaliero
        </span>

        <span class="permission-help">
          Attiva per richiedere il permesso per l'intera giornata.
        </span>

      </div>

      <p-toggleButton
        formControlName="isDaily"
        [(ngModel)]="permission.isDaily"
        onLabel="Sì"
        offLabel="No"
        onIcon="pi pi-check"
        offIcon="pi pi-times"
        styleClass="permission-daily-toggle"
      ></p-toggleButton>

    </div>

    <!-- CONFERMA -->

    <div class="permission-dialog-actions">

      <p-button
        label="Conferma"
        icon="pi pi-check"
        styleClass="permission-confirm-button"
        [loading]="saving"
        [disabled]="formGroup.invalid || saving"
        (onClick)="confirm()"
      ></p-button>

    </div>

  </form>

</div>